<script lang="ts">
    import { cn, type WithElementRef, type WithoutChildren } from "../../../utils.js";
    import type { HTMLTextareaAttributes } from "svelte/elements";

    let {
        ref = $bindable(null),
        value = $bindable(),
        "class": className,
        "data-slot": dataSlot = "textarea",
        ...restProps
    }: WithoutChildren<WithElementRef<HTMLTextareaAttributes>> = $props();
</script>

<textarea
    bind:this={ref}
    data-slot={dataSlot}
    class={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
    )}
    bind:value
    {...restProps}
></textarea>
